import PropTypes from "prop-types";
import "./styles.css";
import TextInput from "../../Inputs/TextInput";
import Select from "../../Inputs/Select";

function CustomerDetailsStep() {
  return (
    <div className="Step CustomerDetailsStep">
      <h2>A few details about you</h2>
      <p>
        To prepare your personalised buyer comparison, we just need a few
        details about you.
      </p>
      <Select
        label="Title"
        inline={true}
        options={["Mr", "Mrs", "Ms", "Dr", "Miss"]}
        statekey="title"
      />
      <TextInput
        inline={true}
        validate="true"
        label="First Name"
        statekey={"first_name"}
      />
      <TextInput
        inline={true}
        validate="true"
        label="Last Name"
        statekey={"last_name"}
      />
      <h3>Contact details</h3>
      <TextInput
        inline={true}
        label="Email"
        validate="email"
        statekey={"email"}
      />
      <TextInput
        inline={true}
        label="Phone Number"
        validate="phone"
        statekey={"phone_number"}
      />
      <p>
        (You’ll receive your personalised cash house buyer comparison summary by
        email and SMS).
      </p>
    </div>
  );
}

export default CustomerDetailsStep;

CustomerDetailsStep.propTypes = {};
